import { Styles, css, withStyles } from '@recruit-robin/robin-theme/web-styles';
import { InfoTableStyleStates } from './types';

const BORDER_RADIUS = 4;

const styles = {
  header: ({ theme }) =>
    css({
      borderTopLeftRadius: BORDER_RADIUS,
      borderTopRightRadius: BORDER_RADIUS,
      background: theme.colors.neutral.variant[10],
      padding: '16px 12px',
      color: theme.colors.neutral.variant[60],
    }),
  body: ({ theme }) =>
    css({
      borderBottomLeftRadius: BORDER_RADIUS,
      borderBottomRightRadius: BORDER_RADIUS,
      background: theme.colors.neutral.variant[0],
      padding: '16px 12px',
      color: theme.colors.neutral.variant[60],
      border: `solid 1px ${theme.colors.neutral.variant[10]}`,
    }),
  pill: css`
    width: 22px;
  `,
  tooltip: css`
    text-align: center;
  `,
} satisfies Styles<InfoTableStyleStates>;

export const useStyles = withStyles(styles);
